export const SET_COUPONS = 'setCoupons'
export const ADD_COUPON = 'addCoupons'
